export default __webpack_public_path__ + "81ce6defe3ea327d317a2bfc1d310c91.ogv";